module.exports = __webpack_public_path__ + "img/horse_image.3640ab7f.jpg";